import { render } from "./ListDataSakit.vue?vue&type=template&id=22609784"
import script from "./ListDataSakit.vue?vue&type=script&lang=js"
export * from "./ListDataSakit.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__